<template lang="pug">
.number-picker
  label(v-if='label' :class='focus ? `primary--text` : `grey--text`') {{ label }}
  .box
    button.minus(type='button' tabindex='-1' @click='decrease' :class='{ disabled: !isDecreasable }')
    input.primary--text(type='tel' :value='x' @change='change' pattern='[0-9]*' @focus='focus = true' @blur='focus = false')
    button.plus(type='button' tabindex='-1' @click='increase' :class='{ disabled: !isIncreasable }')
</template>

<script>
export default {
  name: 'NumberPicker',
  props: {
    value: {
      default: null,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
    label: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      x: 0,
      focus: false,
    }
  },
  methods: {
    change ({ target: { value } }) {
      const { min, max } = this
      if (!Number.isInteger(+value)) throw TypeError('Not a integer!') // 判斷是否為數字
      const n = parseInt(value)

      if (n <= this.max && n >= this.min) {
        this.x = n
      } else {
        if (max === min) this.x = min
        else if (n > max) this.x = max
        else if (n < min) this.x = min
      }
    },
    increase () {
      if (!this.isIncreasable) throw RangeError('已達到 max 值!')
      this.x += 1
    },
    decrease () {
      if (!this.isDecreasable) throw RangeError('已達到 min 值!')
      this.x -= 1
    },
    update (_) {
      this.$emit('input', _)
    },
  },
  computed: {
    isIncreasable () {
      return this.x < this.max
    },
    isDecreasable () {
      return this.x > this.min
    },
    buttonStyle () {
      return {
        backgroundColor: this.color,
      }
    },
  },
  watch: {
    x (_) {
      this.update(_)
    },
    value: {
      immediate: true,
      handler (_) {
        this.x = _
      },
    },
  },
}
</script>

<style scoped lang="sass">
.number-picker
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  width: 100%
  border-radius: 5px
  transition: background-color .2s
  label
    transition: color .3s
    font-size: .9rem
  .box
    display: flex
    justify-content: center
    align-items: center
    input
      text-align: center
      border: 0
      width: 60px
      font-weight: 300
      font-family: Roboto,sans-serif!important
      font-size: 40px
      &:focus
        border: 0
        box-shadow: 0 0 0
    button
      display: flex
      justify-content: center
      align-items: center
      color: white
      border-radius: 100rem
      opacity: .95
      background-color: #333
      width: 20px
      height: 20px
      letter-spacing: 0
      text-align: center
      transition: all .15s
      &:hover
        opacity: 1
        transform: scale(1.05)
      &:active
        transform: scale(.95)
      &.disabled
        opacity: .2
        transform: none
        cursor: no-drop

  input, button
    &:focus
      outline: none

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
  -webkit-appearance: none
  display: none
  margin: 0

$char-weight: 3px

.plus, .minus
  position: relative
  &::after
    position: absolute
    content: '+'
    top: 0
    left: 0
    width: 100%
    height: 100%
    font-size: 16px
    line-height: 18px
    letter-spacing: 0

.minus
  &::after
    content: '-'
</style>
